import { Component, OnInit, ViewChild } from '@angular/core';
import { ShapeComponent } from '../shape/shape.component';
import { ShapeType } from '../../model/shape-types';
import { MousePosition, Circle, Shape } from '../../model/shape';

@Component({
    selector: 'app-circle',
    templateUrl: './circle.component.html',
    styleUrls: ['./circle.component.css']
})
export class CircleComponent extends ShapeComponent implements OnInit {

    formFields: any = [
        {
            name: 'name',
            label: 'Naam:',
            type: 'input',
            inputType: 'text',
        },
        {
            name: 'x',
            label: 'X:',
            type: 'input',
            inputType: 'text',
        },
        {
            name: 'y',
            label: 'Y:',
            type: 'input',
            inputType: 'text',
        },
        {
            name: 'r',
            label: 'Radius:',
            type: 'input',
            inputType: 'text',
            value: ''
        },
        {
            name: 'strokeColor',
            label: 'Stroke color:',
            type: 'colorpicker',
            inputType: 'text',
        },
        {
            name: 'fillColor',
            label: 'Fill color:',
            type: 'colorpicker',
            inputType: 'text',
        },
        {
            name: 'strokeWidth',
            label: 'Stroke width:',
            type: 'input',
            inputType: 'text',
        },
    ];

    constructor() {
        super();
        this.shape = new Circle();

        this.shapeType = ShapeType.Circle;
        //console.log('CircleComponent constructor:', this);
    }

    ngOnInit() {
        //console.log('CircleComponent ngOnInit');
    }

    updateShapeProperties(value: any) {
        //console.log('CircleComponent : updateShapeProperties');
        if (this.shape instanceof Circle) {
            this.shape.shapeProperties.name = value.name;
            this.shape.originX = value.x;
            this.shape.originY = value.y;
            this.shape.r = value.r;
            this.shape.shapeProperties.fillColor = value.fillColor;
            this.shape.shapeProperties.strokeColor = value.strokeColor;
            this.shape.shapeProperties.strokeWidth = value.strokeWidth;
        }
    }

    setStyles() {
        let styles = {
            'stroke': this.shape.shapeProperties.strokeColor,
            'fill': this.shape.shapeProperties.fillColor,
            'stroke-width': this.shape.shapeProperties.strokeWidth
        };
        return styles;
    }

    startDrawing(beginPosition: any): void {
        //console.log('CircleComponent startDrawing at ', beginPosition);
        if (this.shape instanceof Circle) {
            this.shape.originX = beginPosition.startX;
            this.shape.originY = beginPosition.startY;
        }
    }

    draw(currentPosition: any): void {
        //console.log(currentPosition,this.shape.originX);
        if (this.shape instanceof Circle) {
            this.shape.r = Math.abs(currentPosition.x - this.shape.originX);
            this.shape.width = Math.abs(currentPosition.x - currentPosition.startX);
                this.shape.height = Math.abs(currentPosition.y - currentPosition.startY);
                this.shape.originX = (currentPosition.x - currentPosition.startX < 0) ? currentPosition.x : currentPosition.startX;
                this.shape.originY = (currentPosition.y - currentPosition.startY < 0) ? currentPosition.y : currentPosition.startY;
        }
    }

    setSelectionPoints(): void {

        // <!-- < svg: rect attr.x = "{{ shape.originX - shape.r }}" attr.y = "{{ shape.originY - shape.r }}" attr.width = "{{ shape.r * 2 }}"
        // attr.height = "{{ shape.r * 2 }}" style = "stroke: red; stroke-width: 1; stroke-dasharray:5; fill:none" /> -->

    }

    resizeShape(resizePosition: MousePosition) {
        //console.log('CircleComponent: resizeShape ', resizePosition);
    }


}
